import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Select from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import searchFilterAccessorials from "@tKgpco/Handlers/Accessorials/SearchFilterAccessorials";
import setAccessorialSearchFilter from "@tKgpco/Handlers/Accessorials/SetAccessorialSearchFilter";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import { AccessorialsFormValues } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    searchFilterAccessorials,
    setAccessorialSearchFilter,
};

const mapStateToProps = (state: CustomApplicationState) => ({
    selectFilter: state.KGPState.customAccessorials.selectFilter,
    selectFilterText: state.KGPState.customAccessorials.selectFilterText,
});

interface CustomWidgetStyles {
    wrapper?: InjectableCss;
    searchBox?: TextFieldPresentationProps;
}

const styles: CustomWidgetStyles = {
    wrapper: {
        css: css`
            display: flex;
        `,
    },
    searchBox: {
        cssOverrides: {
            formField: css`
            > div {
                margin-top: 5px !important;
            }
            input {
                padding: 0 33px 0 10px !important;
            }
            `,
        }
    }
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const AccessorialSearch: React.FC<Props> = ({
    id,
    searchFilterAccessorials,
    setAccessorialSearchFilter,
    selectFilter,
    selectFilterText,
}) => {
    const doSearch = () => {
        if(selectFilterText === "") {
            searchFilterAccessorials({ queryParams: { page: 1 } });
        } else if (selectFilter && selectFilterText) {
            searchFilterAccessorials({ queryParams: { page: 1, [selectFilter as keyof AccessorialsFormValues]: selectFilterText } });
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.keyCode !== 13) {
            return false;
        }
        doSearch();
    };

    useEffect(() => {
        return () => {
            setAccessorialSearchFilter({ key: "selectFilter", value: "" })
            setAccessorialSearchFilter({ key: "selectFilterText", value: "" })
        }
    },[]);

    useEffect(() => {
        doSearch();
    },[selectFilter, selectFilterText]);

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper
                css={css`
                    max-width: 250px;
                `}
            >
                <Select
                    value={selectFilter}
                    onChange={e => setAccessorialSearchFilter({ key: "selectFilter", value: e.target.value })}
                >
                    <option disabled value="">
                        {translate("Select Column")}
                    </option>
                    <option value="master">{translate("Master")}</option>
                    <option value="name">{translate("Name")}</option>
                    <option value="type">{translate("Type")}</option>
                    <option value="tiCode">{translate("Code")}</option>
                    <option value="tiDescription">{translate("Description")}</option>
                    <option value="enabled">{translate("Enabled")}</option>
                </Select>
            </StyledWrapper>
            <TextField
                onChange={e => setAccessorialSearchFilter({ key: "selectFilterText", value: e.target.value })}
                value={selectFilterText}
                placeholder={translate("Search")}
                iconClickableProps={{ onClick: doSearch }}
                iconProps={{ src: "Search", size: 16 }}
                onKeyDown={handleKeyDown}
                {...styles.searchBox}
            />
        </StyledWrapper>
    );
};

const accessorialSearch: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AccessorialSearch),
    definition: {
        group: "Basic",
    },
};

export default accessorialSearch;
